export default __webpack_public_path__ + "static/media/title_ko_sp.36bf5351.png";